import { render, staticRenderFns } from "./AdminDocuments.vue?vue&type=template&id=070595bd&scoped=true&"
import script from "./AdminDocuments.vue?vue&type=script&lang=js&"
export * from "./AdminDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AdminDocuments.vue?vue&type=style&index=0&id=070595bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070595bd",
  null
  
)

export default component.exports